export enum EndShiftAtHomePreferenceRating {
  STRONGLY_PREFER_AT_HOME = 5,
  PREFER_AT_HOME = 4,
  NO_PREFERENCE = 3,
  PREFER_AWAY_FROM_HOME = 2,
  STRONGLY_PREFER_AWAY_FROM_HOME = 1,
}
